import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { Checkbox } from "../components/ui/checkbox"
import { Label } from "../components/ui/label"

export function CheckboxRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()
  const text = element.text ? String(resolveSymbol(element.text) ?? "") : undefined
  const checked = element.variant === "checked" || resolveSymbol(String(element.visible ?? "")) === true

  const handleCheckedChange = (value: boolean) => {
    dispatchEvent(element.id, "change", { value })
  }

  return (
    <div className={cn("flex items-center space-x-2", element.className)} data-testid={`checkbox-${element.id}`}>
      <Checkbox id={element.id} defaultChecked={checked} onCheckedChange={handleCheckedChange} />
      {text && <Label htmlFor={element.id}>{text}</Label>}
    </div>
  )
}

function cn(...classes: (string | undefined)[]) {
  return classes.filter(Boolean).join(" ")
}
